import React, { useRef } from 'react';
import './BottomTab.sass';
import { useTranslation } from 'react-i18next';

interface Props {
  isPanelOpen: boolean;
  togglePanel: () => void;
  children: React.ReactNode;
  tongueSize?: 'default' | 'small';
  size?: 'default' | 'compact';
}

const BottomTab = ({
  isPanelOpen,
  togglePanel,
  children,
  tongueSize = 'default',
  size = 'default',
}: Props) => {
  const { t } = useTranslation();
  const startYRef = useRef<number | null>(null);
  const deltaYRef = useRef<number>(0);

  const handleTouchStart = (e: React.TouchEvent) => {
    startYRef.current = e.touches[0].clientY;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (startYRef.current !== null) {
      deltaYRef.current = e.touches[0].clientY - startYRef.current;
    }
  };

  const handleTouchEnd = () => {
    if (deltaYRef.current > 50 || deltaYRef.current < -50) {
      togglePanel();
    }
    startYRef.current = null;
    deltaYRef.current = 0;
  };

  return (
    <div
      className={`bottom-tab ${isPanelOpen ? 'open' : 'closed'} ${size === 'compact' ? 'compact' : ''}`}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      aria-expanded={isPanelOpen}
    >
      <div
        className={`bottom-tab__tongue ${tongueSize === 'small' ? 'small' : ''}`}
        onClick={() => {
          togglePanel();
          document.querySelector('.instructions-content')?.scrollTo({ top: 0, behavior: 'smooth' });
        }}
        role="button"
        aria-label={t("capture_face.instructions")}
        tabIndex={0}
      ></div>

      <div className="bottom-tab__content">
        {children}
      </div>
    </div>
  );
};

export default BottomTab;
